import React from "react";

const Title = ({ title, subtitle, modifier }) => {
    return (
        <div
            className={`title-container ${
                modifier ? "title-container--" + modifier : ""
            }`}
        >
            {title && <h1 className="main-title">{title}</h1>}
            {subtitle && <h2 className="sub-title">{subtitle}</h2>}
        </div>
    );
};

export default Title;
